angular.module("app").controller("GamesEditPageController", [
    '$scope',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'preloadedProviders',
    'casinoGameTypes',
    '$filter',
    'ratios',
    'pageStatuses',
    'logger',
    'preloadedGameData',
    'deepCompare',
    'settingsService',
    '$uibModalInstance',
    '$timeout',
    'Utils',
    'countryCodes',
    'casinoJackpot',
    'casinoPaylines',
    'casinoVolatility',
    'preloadedFeatures',
    'preloadedThemes',
    'preloadedLicense',
    'currencies',
    function ($scope, casinoGameService, errorHandler, preloadedCategories, preloadedProviders, casinoGameTypes, $filter, ratios, pageStatuses, logger, preloadedGameData, deepCompare, settingsService, $modalInstance, $timeout, Utils, countryCodes, casinoJackpot, casinoPaylines, casinoVolatility, preloadedFeatures, preloadedThemes, preloadedLicense, currencies) {
        var init,
            types = [],
            translator = $filter('translate'),
            settings = settingsService.getSettings(),
            addElementHelper = null;
        var countryNameCodeMap = {};
        var countryCodeNameMap = {};
        $scope.countryCodes = countryCodes.data.map(function (item) {
            countryNameCodeMap[item.name] = item["alpha-2"];
            countryCodeNameMap[item["alpha-2"]] = item.name;
            return item.name;
        });
        $scope.currencies = currencies.data;
        $scope.customRatioErrorContainer = {
            show: false
        };
        var DEFAULT_LICENSE_ID = 3;

        var categoryTitleIdMap = {};
        var categoryIdTitleMap = {};
        var casinoGameTypeIdMap = {};
        var casinoGameIdTypeMap = {};
        var themeTitleIdMap = {};
        var themeIdTitleMap = {};
        var featureTitleIdMap = {};
        var featureIdTitleMap = {};
        var licenseNameIdMap = {};
        var licenseIdNameMap = {};
        var deletedIds = [];
        casinoGameTypes.forEach(function (value) {
            types.push({
                id: value,
                title: translator('casinoGame.addEdit.types.' + value)
            })
        });

        $scope.ratios = ratios;

        var tmpLanguages = [];

        angular.forEach(settings.languages, function (lang) {
            if (lang == 'en') return true;

            tmpLanguages.push({
                id: lang,
                title: lang.toUpperCase() + ' - ' + translator('top_menu.languages.' + lang),
                placeholder: 'Name'
            });
        });

        $scope.languages = tmpLanguages;

        $scope.pageStatuses = pageStatuses;


        $scope.tooltip = {
            name: "",
            height: "",
            server_game_id: "",
            width: "",
            downloadLinkWindows: "",
            downloadLinkLinux: "",
            downloadLinkMac: ""
        };
        $scope.uploadCache = {
            icons: [],
            icons2: [],
            backgrounds: []
        };

        $scope.imagesState = {
            selectedIcon2: 0,
            selectedIcon: 0,
            selectedLicenseIcon: 0,
            selectedBackground: 0
        };

        $scope.paylines = angular.copy(casinoPaylines);
        $scope.volatility = angular.copy(casinoVolatility);
        $scope.jackpot = angular.copy(casinoJackpot);

        function fixImages(newImages, oldImages) {
            var result = [];
            var previousDefaultId;
            if (oldImages.length > 0) {
                oldImages.forEach(function (item) {
                    if (item.default === '1') {
                        previousDefaultId = item.id;
                    }
                });
            }
            newImages.forEach(function (item) {
                if (!!item.icon || (item.default === '1' && item.id !== previousDefaultId)) {
                    result.push(item);
                }
            });
            return result;
        }

        $scope.save = function () {
            addElementHelper = $scope.useAddElementHelper();
            if (!$scope.add_games_form.$valid) {
                $scope.customRatioErrorContainer.show = true;
                $scope.isSavePressed = true;
                return;
            } else if ($scope.isAllowedToUpdate()) {
                logger.logError("global.no_changes");
                return;
            }
            var fetchedData = fetchRequestData(),
                requestData = {
                    casinoGame: angular.copy(fetchedData)
                },
                changes;

            changes = deepCompare.getChanges(preloadedGameData, requestData.casinoGame) || deepCompare.getChanges(requestData.casinoGame, preloadedGameData) || {};
            changes.id = preloadedGameData.id;
            changes.backgrounds = fixImages(fetchedData.backgrounds, preloadedGameData.backgrounds);
            changes.icons = fixImages(fetchedData.icons, preloadedGameData.icons);
            changes.icons2 = fixImages(fetchedData.icons2, preloadedGameData.icons2);
            changes.licenseIcons = fixImages(fetchedData.licenseIcons, preloadedGameData.licenseIcons);

            changes.deletedIds = fetchedData.deletedIds;
            changes.categories = requestData.casinoGame.categories;
            changes.categories = changes.categories.filter(element => {
                return element !== null && element !== undefined;
            });
            changes.types = requestData.casinoGame.types;
            changes.themes = requestData.casinoGame.themes;
            changes.features = requestData.casinoGame.features;
            if (!angular.equals(preloadedGameData.licenses, requestData.casinoGame.licenses)) {
                changes.licenses = requestData.casinoGame.licenses;
            }
            changes.translations = fetchedData.translations;
            changes.blocked_currencies = requestData.casinoGame.blocked_currencies;

            /*  if (! angular.equals($scope.preloadedBadge, $scope.gameData.badge)) {
                  changes.badge = $scope.gameData.badge;
              }*/

            if (!angular.equals($scope.preloadedBlockedCountries, requestData.casinoGame.blocked_countries)) {
                changes.blocked_countries = requestData.casinoGame.blocked_countries;
            } else {
                delete changes.blocked_countries;
            }

            requestData.casinoGame = changes;

            casinoGameService.edit(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");

                        casinoGameService.get({id: preloadedGameData.id}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    init(angular.copy(response.game));
                                    $modalInstance.close();
                                }
                            }
                        );

                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            return deepCompare.isEqual(fetchRequestData(true), preloadedGameData)
        };

        function fetchRequestData(forCompare) {
            var fetchedData = angular.extend({}, $scope.gameData);
            fetchedData.blocked_countries = fetchedData.blocked_countries.map(function (value) {
                return countryNameCodeMap[value];
            });
            fetchedData.is_mobile = fetchedData.is_mobile ? "1" : "0";
            fetchedData.justice = fetchedData.justice ? "1" : "0";
            fetchedData.manually = fetchedData.manually ? "1" : "0";
            fetchedData.deletedIds = deletedIds;
            fetchedData.categories = [];
            fetchedData.types = [];
            fetchedData.translations = addElementHelper.fetchData('gameNameTranslation');
            fetchedData.icons = [];
            fetchedData.icons2 = [];
            fetchedData.licenseIcons = [];
            fetchedData.backgrounds = [];
            fetchedData.themes = [];
            fetchedData.features = [];
            fetchedData.licenses = [];
            fetchedData.is_mini_game = fetchedData.is_mini_game ? "1" : "0";

            $scope.gameData.icons.forEach(function (value, index) {
                var image = {
                    default: $scope.imagesState.selectedIcon === index ? "1" : "0"
                };
                if (value.id) {
                    image.id = value.id;
                }
                if (value.icon.indexOf('data:image') !== -1) {
                    image.icon = value.icon;
                }
                fetchedData.icons.push(image);


            });

            $scope.gameData.icons2.forEach(function (value, index) {
                var image = {
                    default: $scope.imagesState.selectedIcon2 === index ? "1" : "0"
                };
                if (value.id) {
                    image.id = value.id;
                }
                if (value.icon.indexOf('data:image') !== -1) {
                    image.icon = value.icon;
                }
                fetchedData.icons2.push(image);
            });
            $scope.gameData.licenseIcons.forEach(function (value, index) {
                var image = {
                    default: $scope.imagesState.selectedLicenseIcon === index ? "1" : "0"
                };
                if (value.id) {
                    image.id = value.id;
                }
                image.license_id = value.license_id || DEFAULT_LICENSE_ID;
                if (value.icon.indexOf('data:image') !== -1) {
                    image.icon = value.icon;
                }
                fetchedData.licenseIcons.push(image);

            });
            $scope.gameData.backgrounds.forEach(function (value, index) {
                var image = {
                    default: $scope.imagesState.selectedBackground === index ? "1" : "0"
                };
                if (value.id) {
                    image.id = value.id;
                }
                if (value.background.indexOf('data:image') !== -1) {
                    image.icon = value.background;
                }
                fetchedData.backgrounds.push(image);
            });
            $scope.multiSelect.selectedCategories.forEach(function (value) {
                fetchedData.categories.push(categoryTitleIdMap[value])
            });
            $scope.multiSelect.selectedCasinoGameTypes.forEach(function (value) {
                fetchedData.types.push(casinoGameTypeIdMap[value]);
            });
            $scope.multiSelect.selectedThemes.forEach(function (value) {
                fetchedData.themes.push(themeTitleIdMap[value]);
            });
            $scope.multiSelect.selectedFeatures.forEach(function (value) {
                fetchedData.features.push(featureTitleIdMap[value]);
            });
            $scope.multiSelect.selectedLicenses.forEach(function (value) {
                fetchedData.licenses.push(licenseNameIdMap[value]);
            });
            /*  if(fetchedData.badge.value !== '0') {
                  if (!fetchedData.badge.from && $scope.vm.dateTimeFrom) {
                      fetchedData.badge.from =  moment($scope.vm.dateTimeFrom).tz("Asia/Yerevan").format()
                  }
                  if (!fetchedData.badge.to && $scope.vm.dateTimeTo) {
                      fetchedData.badge.to =  moment($scope.vm.dateTimeTo).tz("Asia/Yerevan").format()
                  }
              }*/
            return fetchedData
        }

        function loadExtraCategories(categoryId) {
            casinoGameService.getExtraCategories({ category_id: categoryId }).then(function (response) {
                $scope.extraCategories = response.data;
                const selectedCategory = response.data.find(item => item.value === $scope.gameData.extra_category) || response.data[0];

                if (selectedCategory) {
                    $scope.gameData.extra_category = selectedCategory.value;
                }
            });
        }

        $scope.changeCategory = function () {
            const selectedCategories = $scope.multiSelect.selectedCategories;

            if (selectedCategories && selectedCategories.length > 0) {
                const selectedCategoryTitle = selectedCategories.find((category) => category === 'Live Dealer' || category === 'Virtual Betting'  || category === 'Skill Games');
                const categoryId = categoryTitleIdMap[selectedCategoryTitle];

                if (selectedCategoryTitle === 'Live Dealer' || selectedCategoryTitle === 'Virtual Betting' || selectedCategoryTitle === 'Skill Games') {
                    loadExtraCategories(categoryId);
                    $scope.showExtraCategory = true;
                } else {
                    $scope.showExtraCategory = false;
                    delete $scope.gameData.extra_category;
                }
            } else {
                $scope.showExtraCategory = false;
                delete $scope.gameData.extra_category;
            }
        };

        (init = function (gameData) {
            var categories = [];

            $scope.multiSelect = {};


            $scope.multiSelect.casinoGameTypeTitles = types.map(function (item) {
                casinoGameTypeIdMap[item.title] = item.id;
                casinoGameIdTypeMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedCasinoGameTypes = gameData.types.map(function (item) {
                return casinoGameIdTypeMap[item];
            });
            $scope.multiSelect.categoryTitles = angular.copy(preloadedCategories).map(function (item) {
                categoryTitleIdMap[item.title] = item.id;
                categoryIdTitleMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedCategories = gameData.categories.map(function (category) {
                return categoryIdTitleMap[category.id];
            });

            $scope.multiSelect.themeTitles = preloadedThemes.map(function (item) {
                themeTitleIdMap[item.title] = item.id;
                themeIdTitleMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedThemes = (gameData.themes && (gameData.themes.map(function (item) {
                return themeIdTitleMap[item.id];
            }))) || [];

            $scope.multiSelect.featureTitles = preloadedFeatures.map(function (item) {
                featureTitleIdMap[item.title] = item.id;
                featureIdTitleMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedFeatures = (gameData.features && (gameData.features.map(function (item) {
                return featureIdTitleMap[item.id];
            }))) || [];

            $scope.multiSelect.licenseNames = preloadedLicense.map(function (item) {
                licenseNameIdMap[item.name] = item.id;
                licenseIdNameMap[item.id] = item.name;
                return item.name;
            });
            $scope.multiSelect.selectedLicenses = (gameData.licenses && (gameData.licenses.map(function (item) {
                return licenseIdNameMap[item];
            }))) || [];
            $scope.providers = angular.copy(preloadedProviders);

            gameData.front_game_id = gameData.provider + '' + gameData.server_game_id;

            //  gameData.categories = angular.copy(categories);

            /*   var badgeValue = gameData.badge;
               gameData.badge = {
                   value: badgeValue,
                   from: gameData.badge_start_date,
                   to: gameData.badge_end_date
               };

               $scope.preloadedBadge = gameData.badge;*/
            $scope.preloadedBlockedCountries = gameData.blocked_countries;
            $scope.gameData = angular.copy(gameData);
            $scope.gameData.blocked_countries = $scope.gameData.blocked_countries && $scope.gameData.blocked_countries.map(function (value) {
                return countryCodeNameMap[value];
            }) || [];
            var iconsLength = $scope.gameData.icons.length;
            var icons = [];

            for (var i = 0; i < iconsLength; ++i) {
                var icon = $scope.gameData.icons[i];
                if (icon.default === '1') {
                    $scope.imagesState.selectedIcon = i;
                }
                var imageLink = icon['icon_1'] ? icon['icon_1'] : (icon['icon_2'] ? icon['icon_2'] : icon['icon_3']);
                icons.push({id: icon.id, icon: imageLink});
            }
            $scope.gameData.icons = icons;
            var icons2Length = $scope.gameData.icons2.length;
            var icons2 = [];

            for (var i = 0; i < icons2Length; ++i) {
                var icon = $scope.gameData.icons2[i];
                if (icon.default === '1') {
                    $scope.imagesState.selectedIcon2 = i;
                }
                var imageLink = icon['icon_1'] ? icon['icon_1'] : (icon['icon_2'] ? icon['icon_2'] : icon['icon_3']);
                icons2.push({id: icon.id, icon: imageLink});
            }
            $scope.gameData.icons2 = icons2;
            $scope.gameData.licenseIcons = $scope.gameData.licenseIcons || [];
            var licenseIconsLength = $scope.gameData.licenseIcons.length;
            var licenseIcons = [];

            for (var i = 0; i < licenseIconsLength; ++i) {
                var icon = $scope.gameData.licenseIcons[i];
                if (icon.default === '1') {
                    $scope.imagesState.selectedLicenseIcon = i;
                }
                var imageLink = icon['icon_1'] ? icon['icon_1'] : (icon['icon_2'] ? icon['icon_2'] : icon['icon_3']);
                licenseIcons.push({id: icon.id, icon: imageLink, license_id: icon.license_id});
            }
            $scope.gameData.licenseIcons = licenseIcons;
            var backgrounds = [];
            var backgroundsLength = $scope.gameData.backgrounds.length;
            for (var i = 0; i < backgroundsLength; ++i) {
                var background = $scope.gameData.backgrounds[i];
                if (background.default === '1') {
                    $scope.imagesState.selectedBackground = i;
                }
                backgrounds.push(background);
            }
            $scope.gameData.backgrounds = backgrounds;
            /* if($scope.gameData.badge.value !== "0") {
                 $scope.vm = {
                     dateTimeFrom:  gameData.badge.from && $filter("convertDateToUserTimezone")(moment(new Date(gameData.badge.from)).format('DD/MM/YYYY, HH:mm:ss'), 'DD/MM/YYYY, HH:mm:ss') || "",
                     dateTimeTo:  gameData.badge.to && $filter("convertDateToUserTimezone")(moment(new Date(gameData.badge.to)).format('DD/MM/YYYY, HH:mm:ss'), 'DD/MM/YYYY, HH:mm:ss') || "",
                     notFormat: true
                 };
             }*/

            $scope.gameData.front_game_id = $scope.gameData.provider + '' + $scope.gameData.server_game_id;
            preloadedGameData = angular.copy(gameData);
            $scope.add_games_form && $scope.add_games_form.$setPristine();

            if (gameData.translations != undefined && gameData.translations.name != undefined) {
                $scope.gameNameTranslation = angular.copy(gameData.translations.name);
            }
            $scope.gameData.paylines = $scope.gameData.paylines || "";
            $scope.gameData.volatility = $scope.gameData.volatility || casinoVolatility[0].value;
            $scope.gameData.jackpot = $scope.gameData.jackpot || casinoJackpot[0].value;
            $scope.gameData.is_mobile = $scope.gameData.is_mobile === "1";
            $scope.gameData.justice = $scope.gameData.justice === "1";
            $scope.gameData.manually = $scope.gameData.manually === "1";
            $scope.gameData.is_mini_game = $scope.gameData.is_mini_game === "1";
            $scope.gameData.blocked_currencies = $scope.gameData.blocked_currencies || [];
            $scope.changeCategory();
        })(angular.copy(preloadedGameData));
        /*

                $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
                    if (this.from) {
                        $scope.vm.dateTimeFrom = dateTime;
                        $scope.vm.fromDate = dateToSave || undefined;
                        $scope.gameData.badge.from = $scope.vm.fromDate;
                    } else {
                        $scope.vm.dateTimeTo = dateTime;
                        $scope.vm.toDate = dateToSave || undefined;
                        $scope.gameData.badge.to = $scope.vm.toDate;
                    }
                };

                $scope.setBadgeDate = function (badge) {

                    if (badge !== '0') {
                        $scope.vm = {
                            dateTimeFrom: moment(new Date()).format('DD/MM/YYYY, HH:mm:ss'),
                            dateTimeTo: moment(new Date()).add('1','month').format('DD/MM/YYYY, HH:mm:ss'),
                            notFormat: true
                        };
                    }
                };
        */

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.resetMiniGameOptions = function () {
            if ($scope.gameData.is_mini_game) {
                $scope.gameData.mini_game_options = "";
            }
        };

        $scope.$watch('uploadCache.icon', function () {
            if ($scope.uploadCache.icon && angular.isString($scope.uploadCache.icon)) {
                $scope.gameData.icons.push({icon: $scope.uploadCache.icon});
                $scope.uploadCache.icon = false;
            }
        });

        $scope.$watch('uploadCache.icon2', function () {
            if ($scope.uploadCache.icon2 && angular.isString($scope.uploadCache.icon2)) {
                $scope.gameData.icons2.push({icon: $scope.uploadCache.icon2});
                $scope.uploadCache.icon2 = false;
            }
        });

        $scope.$watch('uploadCache.licenseIcon', function () {
            if ($scope.uploadCache.licenseIcon && angular.isString($scope.uploadCache.licenseIcon)) {
                $scope.gameData.licenseIcons.push({icon: $scope.uploadCache.licenseIcon});
                $scope.uploadCache.licenseIcon = false;
            }
        });

        $scope.$watch('uploadCache.background', function () {
            if ($scope.uploadCache.background && angular.isString($scope.uploadCache.background)) {
                $scope.gameData.backgrounds.push({background: $scope.uploadCache.background});
                $scope.uploadCache.background = false;
            }
        });


        $scope.deleteIconOrBackground = function (data, flug) {
            var id;
            if (flug === 'background') {
                id = $scope.gameData.backgrounds[data].id;
                $scope.gameData.backgrounds.splice(data, 1);
                if ($scope.imagesState.selectedBackground === data) {
                    $scope.imagesState.selectedBackground = 0;
                } else if ($scope.imagesState.selectedBackground > data) {
                    $scope.imagesState.selectedBackground -= 1;
                }
            } else if (flug === 'icons') {
                id = $scope.gameData.icons[data].id;
                $scope.gameData.icons.splice(data, 1);
                if ($scope.imagesState.selectedIcon === data) {
                    $scope.imagesState.selectedIcon = 0;
                } else if ($scope.imagesState.selectedIcon > data) {
                    $scope.imagesState.selectedIcon -= 1;
                }
            } else if (flug === 'icons2') {
                id = $scope.gameData.icons2[data].id;
                $scope.gameData.icons2.splice(data, 1);
                if ($scope.imagesState.selectedIcon2 === data) {
                    $scope.imagesState.selectedIcon2 = 0;
                } else if ($scope.imagesState.selectedIcon2 > data) {
                    $scope.imagesState.selectedIcon2 -= 1;
                }
            } else if (flug === 'licenseIcons') {
                id = $scope.gameData.licenseIcons[data].id;
                $scope.gameData.licenseIcons.splice(data, 1);
                if ($scope.imagesState.selectedLicenseIcon === data) {
                    $scope.imagesState.selectedLicenseIcon = 0;
                } else if ($scope.imagesState.selectedLicenseIcon > data) {
                    $scope.imagesState.selectedLicenseIcon -= 1;
                }

            }
            id && (deletedIds.push(id));
        };

    }
]);
